import styles from "./CandidateBadge.module.scss";
import { getCategoryString } from "./helpers";
import { Badge } from "@aurora/components";
import cx from "classnames";
import { FC } from "react";

const CandidateBadge: FC<Props> = ({ badge }) => {
  if (!badge || !badge.stateCategoryCode) {
    return null;
  }

  return (
    <div title={badge.stateTitle}>
      <Badge
        className={cx(styles.CandidateBadge, "truncate-cell")}
        color={getCategoryString(badge.stateCategoryCode)}
        label={badge.stateTitle}
        theme={"light"}
        variant={"fh-v2"}
      />
    </div>
  );
};

export default CandidateBadge;
